// EntityCache.js
//
// MODEL: platte Map<rk, row> — 1 row per entity. `setRow(rk, partial)` merget
// (Object.assign) i.p.v. vervangt, zodat verschillende services elk hun eigen velden
// kunnen sturen zonder elkaar te overschrijven. `type` is gewoon een veld op de row,
// geen speciaal geval.
//
// `ems` = wanneer deze row voor het laatst is bijgewerkt, punt — dit is het BE-envelope
// veld (zie EntityCard Data Message, Jerny.Development), niet een FE-verzonnen tijdstip.
// Er is bewust GEEN los `lastSeenEms` meer: dat was hetzelfde concept twee keer onder
// een andere naam (FE noemde het updatedEms, een "offline"-scenario noemde het
// lastSeenEms) — of de laatste push online:true of online:false zei, `ems` is en blijft
// "wanneer hoorden we voor het laatst iets van deze entity".
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'EntityCache';

class EntityCache extends CoreBase {
    _name = _name;

    _rows = new Map(); // rk -> plat entity-object, bv. { rk, type, power, peak, ..., ems }

    /**
     * Merget `partial` in de bestaande row van deze entity (of maakt een nieuwe row aan
     * als de entity nog onbekend is). Bestaande velden die niet in `partial` zitten
     * blijven ongemoeid.
     *
     * @param {string} rk - entity-identiteit, bv. 'eco-01'
     * @param {object} partial - velden om te zetten/overschrijven op deze entity
     * @param {number} [ems] - wanneer deze update gemeten/verstuurd is (BE-envelope); default = nu
     */
    setRow = (rk, partial, ems = Date.now()) => {
        const existing = this._rows.get(rk) ?? { rk };
        this._rows.set(rk, { ...existing, ...partial, ems });
    };

    /**
     * @param {string} rk - entity-identiteit, bv. 'eco-01'
     * @returns {object|null} de platte row, of null als deze entity nog nooit geset is
     */
    getRow = (rk) => this._rows.get(rk) ?? null;
}

const entityCache = new EntityCache();
export default entityCache;
